import { Image } from '@/isomorphic/components/image/image';
import { Link } from 'react-router-dom';
import { InsightGroup } from '@/queries/insights';
import { InsightListItem, useInsights } from '@/hooks/use-insights';
import { Terms } from './terms';

type Props = {
    insight: InsightListItem;
    group: InsightGroup;
};

export const InsightsListCard = ({ insight, group }: Props) => {
    const { basePath, sortedTerms, goTo } = useInsights();
    const { slug, title, preamble, image, terms } = insight;

    return (
        <div className="max-md:r-col-span-2">
            <Link to={`${basePath}/${slug}`}>
                {image && (
                    <Image
                        src={image.src}
                        size="500xAUTO"
                        altText={image.alt_text}
                        width={image.originalSize.width}
                        height={image.originalSize.height}
                    />
                )}
                <h2 className="r-mb-4 r-text-2xl r-font-medium">{title}</h2>
                <div className="r-mb-4" dangerouslySetInnerHTML={{ __html: preamble }} />
            </Link>
            <Terms terms={terms} sortedTerms={sortedTerms} basePath={basePath} goTo={goTo} group={group} />
        </div>
    );
};
